import { twMerge } from "tailwind-merge";

import { IconProps } from "~/common/utils/types";

export const LetterIcon = ({ className, ...props }: IconProps) => (
  <svg
    className={twMerge("size-5", className)}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_19898_22013)">
      <path
        d="M2.50008 4.16927L8.97685 9.20676C9.5787 9.67486 10.4215 9.67486 11.0233 9.20676L17.5001 4.16927M4.33342 16.6693H15.6667C16.6002 16.6693 17.0669 16.6693 17.4234 16.4876C17.737 16.3278 17.992 16.0729 18.1518 15.7593C18.3334 15.4027 18.3334 14.936 18.3334 14.0026V6.0026C18.3334 5.06918 18.3334 4.60247 18.1518 4.24595C17.992 3.93235 17.737 3.67738 17.4234 3.51759C17.0669 3.33594 16.6002 3.33594 15.6667 3.33594H4.33341C3.39999 3.33594 2.93328 3.33594 2.57676 3.51759C2.26316 3.67738 2.00819 3.93235 1.8484 4.24595C1.66675 4.60247 1.66675 5.06918 1.66675 6.0026V14.0026C1.66675 14.936 1.66675 15.4027 1.8484 15.7593C2.00819 16.0729 2.26316 16.3278 2.57676 16.4876C2.93328 16.6693 3.39999 16.6693 4.33342 16.6693Z"
        stroke="currentColor"
        strokeWidth="2"
      />
    </g>
    <defs>
      <clipPath id="clip0_19898_22013">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
